var Admin__OrganizationsController;

import OrganizationNavigator from 'trunks/vue/admin/compositions/organizations_sidebar/organization_navigator.js';

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import MembersTable from 'trunks/vue/admin/compositions/datable_table/members_table.js';

import OrganizationInfoContainer from 'trunks/vue/admin/components/organizations/users_organizations_container/organization_info.js';

import GenerateUserProfile from 'trunks/controllers/admin/user_profile/generate_profile.js';

export default Admin__OrganizationsController = (function() {
  class Admin__OrganizationsController extends Skylark.App.BaseController {
    members() {
      var members_table_el;
      this._generateOrganizationSidebarView('members');
      members_table_el = DomMaster.find('#js_members_container').node;
      return this._generateUserProfile((profileSchema) => {
        return new MembersTable({
          el: members_table_el,
          propsData: {
            fieldable: {
              fields: profileSchema.fields
            },
            datableGID: new Skylark.Libs.GlobalID(`gid://skylark/Organization/${this.getIds()[0]}`),
            resourceUrl: "/admin/organizations/members.json"
          }
        });
      });
    }

    show() {
      var id, organization_container;
      id = this.getIds()[0];
      this._generateOrganizationSidebarView(id);
      organization_container = DomMaster.find("#js-organization-container").node;
      return new OrganizationInfoContainer({
        el: organization_container,
        propsData: {
          organization: this.getVars('organization'),
          bindedMembersCount: this.getVars('binded_members_count'),
          membersCount: this.getVars('members_count'),
          applyLink: this.getVars('apply_link'),
          organizationApplicationsCount: this.getVars('pending_organization_applications_count'),
          editOrganizationFunc: (organization) => {
            return this.sidebarVm.openUpdateOrganizationModal(organization, function() {
              return Turbolinks.visit();
            });
          },
          editProfileFunc: (organization) => {
            return this.sidebarVm.openUpdateProfileModal(organization, function() {
              return Turbolinks.visit();
            });
          }
        }
      });
    }

  };

  Admin__OrganizationsController.include(GenerateMorePopover);

  Admin__OrganizationsController.include(OrganizationNavigator);

  Admin__OrganizationsController.include(GenerateUserProfile);

  return Admin__OrganizationsController;

}).call(this);
